module.exports = __webpack_public_path__ + "static/media/video-session.8a3462bb.svg";